export default __webpack_public_path__ + "static/hero-45a2e4da226919d25b8891d50122f06e.jpg";